import type { FromInterface } from '../../common/types';
import _schedules from './schedules';

export default {
  schedules: _schedules
} satisfies FromInterface;
